import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";
import './../styles/faq.css'

const FAQ = () => {
  const [activeQuestion, setActiveQuestion] = useState(null);

  const faqData = [
    {
      question: "When is the best time to visit India?",
      answer:
        "The ideal time to explore India varies by region. For Ladakh and the Himalayas, summer is best. North and South India shine in the winter (October to mid-March). Even the summer rainy season (July to September) offers a unique opportunity to visit places like Rajasthan without breaking the bank.",
    },
    {
      question: "What's the best way to travel around India?",
      answer:
        "Road trips are the ultimate way to experience India's diverse landscapes. Renting a car is often the most cost-effective and flexible way to explore, especially when venturing off the beaten path.",
    },
    {
      question: "Is it safe to travel in India?",
      answer:
        "Absolutely. India is a safe destination with helpful locals who assist travelers in times of need. While the majority of India is safe, exercise caution in certain areas during late nights or early mornings.",
    },
    {
      question: "What services do we offer?",
      answer:
        "The Rustic Paths is your one-stop solution for all your travel needs. We specialize in heritage, cultural, pilgrimage, wildlife, adventure, and special interest tours across India, providing comprehensive services from accommodation to transportation.",
    },
    {
      question: "How do I plan my tour?",
      answer:
        "Planning your tour is easy. Browse our website for well-designed tour packages or share your specific requirements, and we will create a customized trip tailored to your preferences and budget.",
    },
    {
      question: "How can I make a booking with you?",
      answer:
        "To book a tour or hire our car and driver services, simply send us an email with your details, and we will assist you in making the arrangements.",
    },
    {
      question: "Do we provide only all-inclusive holiday packages?",
      answer:
        "While we specialize in all-inclusive packages, we also offer individual services like hotel reservations, car or coach rentals with drivers, and flight or train tickets for those who prefer more flexibility.",
    },
    {
      question: "What are the payment terms?",
      answer:
        "Typically, we require an advance payment once your tour arrangements are confirmed. Payment options include bank transfer, credit card, traveler's cheques, or cash, with exact terms provided upon reservation.",
    },
    {
      question: "What kinds of vehicles do you have?",
      answer:
        "We offer a range of vehicles to suit your needs, from 3-passenger AC Swift D'Zire to larger coaches for groups. For a more luxurious experience, we can arrange premium vehicles at an additional cost.",
    },
    {
      question: "Who will greet me upon my arrival in India?",
      answer:
        "Upon your arrival in India, a warm welcome awaits you from our dedicated representative at the airport. Look for a placard bearing your name, making identification effortless. Rest assured, we will equip you with a list of 24-hour emergency contact numbers, ensuring your peace of mind throughout your journey.",
    },
    // Add more FAQ items as needed
  ];

  const toggleAccordion = (index) => {
    if (activeQuestion === index) {
      setActiveQuestion(null);
    } else {
      setActiveQuestion(index);
    }
  };

  return (
    <section>
      <Container>
      <Row>
        <Col lg='8'>
        <h2>Frequently Asked Questions</h2>
      {faqData.map((faq, index) => (
        <div key={index} className="faq-item">
          <div
            className={`faq-question ${
              index === activeQuestion ? "active" : ""
            }`}
            onClick={() => toggleAccordion(index)}
          >
            {faq.question}
          </div>
          {index === activeQuestion && (
            <div className="faq-answer">{faq.answer}</div>
          )}
        </div>
      ))}
        </Col>
      </Row>
      
    </Container>
    </section>
    
  );
};

export default FAQ;
